import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from "react-router-dom";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Page from '../Page/Page';
import utils, { currency } from '../../utils';
import RefreshButton from '../RefreshButton/RefreshButton';
import OmaveroStatusIcon from './OmaveroStatusIcon';


@inject('omaveroStore')
class OmaveroRow extends Component {
  handleClick = () => {
    this.props.omaveroStore.show(this.props.data);
  }

  render() {
    const { data } = this.props;

    let primary = utils.ymd2dmy(data.PAIVAMAARA, true);
    let secondary = data.KOHDEVUOSI + ' / ' + data.KOHDEKAUSI;

    if (data.korjaus) {
      primary += ' - Korjaus'
    }

    if (data.alv) {
      secondary += ', ALV';
    }
    if (data.tas) {
      secondary += ', TAS';
    }

    return (
      <ListItem
        button
        onClick={this.handleClick}
      >
        <OmaveroStatusIcon data={data} />

        <ListItemText
          primary={primary}
          secondary={secondary}
        />

        <div className="text-right">
          <div>{currency(data.YHTEENSA)}</div>
        </div>
      </ListItem>
    );
  }
}

@inject('omaveroStore')
@withRouter
@observer
class Omaverot extends Component {
  componentDidMount() {
    this.props.omaveroStore.fetchIndex();
  }

  render() {
    const { omaveroStore } = this.props;
    const items = omaveroStore.list;

    return (
      <Page
        title="Omavero"
        searchActive={omaveroStore.searchActive}
        searchValue={omaveroStore.searchValue}
        searchPlaceholder="Hae toimittajan ostolaskuja"
        onSearchClose={omaveroStore.closeSearch}
        onSearchChange={omaveroStore.searchChange}
        forbidden={!omaveroStore.hasModule}
        error={!items && omaveroStore.indexError}
        loading={omaveroStore.isLoadingIndex}
        onRetry={omaveroStore.fetchIndex}
        empty={items && !items.length}
        contentRef={this.contentMounted}
        scrollTop={omaveroStore.scrollTop}
        actions={
          <div className="row">
            <RefreshButton
              loading={omaveroStore.isLoadingIndexBackground}
              onClick={omaveroStore.refreshIndex}
            />
          </div>
        }
      >
        {
          <div>
            {
              items &&

              <List>
                {
                  items.map((item, idx) =>
                    <OmaveroRow key={idx} data={item} />
                  )
                }
              </List>
            }
          </div>
        }
      </Page>
    );
  }
}

export default Omaverot;
